export default `float s=3., e, offset = 1.; 
    for(int i=0;i++<8;p*=e)
      p=abs(p-vec3(1.0,3.0,1.5+offset*.3))-vec3(1.0,3.+offset*.3,2.0),
      p*=-1., s*=e=7./clamp(dot(p,p),.7,7.);
    return (p.z)/s+1e-3;
  }`